"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var styleOverrides = {
    root: function(param) {
        var theme = param.theme;
        return {
            justifyContent: 'center',
            minHeight: 'unset',
            position: 'relative',
            '&:after': {
                position: 'absolute',
                bottom: 0,
                content: '""',
                width: '100%',
                height: 3,
                backgroundColor: theme.palette.grey[200]
            }
        };
    },
    indicator: function(param) {
        var theme = param.theme;
        return {
            height: 3,
            zIndex: 1,
            backgroundColor: theme.palette.text.primary
        };
    },
    scroller: {
        flexGrow: 0,
        zIndex: 1
    }
};
var defaultProps = {
    textColor: 'primary'
};
var _default = exports.default = {
    styleOverrides: styleOverrides,
    defaultProps: defaultProps
}; //# sourceMappingURL=MuiTabs.js.map
